import Styles from './Colors.scss';

import Template from './Colors.hbs';
import Button from 'views/components/wysiwyg/parts/buttons/Button';
import ColorPopupTemplate from 'views/components/wysiwyg/parts/buttons/colors/ColorsPopup.hbs';
import ColorsButtonTemplate from 'views/components/wysiwyg/parts/buttons/colors/ColorButton.hbs';

export default class ColorsInput extends Button {

    // TinyMCE command as default or defined in wysiwyg.js
    command = 'ForeColor'

    // These colors are hard-copied from DrawingCanvasUtil.js as we can't import these dynamically
    get colors() {
        return [
            '#000000', '#de2ea0', '#2ba5ff',
            '#53ffcd', '#45d71a', '#ff4d49',
            '#ff9d2b', '#f0da1d', '#9b9b9b'
        ]
    }

    // Initialize function for initializing button specific logic
    initializeButton() {

        // Make this scope accessible within given functions
        _.bindAll(this,
            'openPopupMenu',
            'onChosenColor',
            'mouseUpDocument'
        );

        // Set the icon to the template
        this.icon = Template();

        // Set the tooltip to a translated string
        this.tooltip = window.i18n.gettext('Colors');
    }

    mouseUpDocument(e) {
        // if the target of the click isn't the container this.$el...
        // ... nor a descendant of the container this.$el
        if (this.el.contains(e.target) === false) {
            this.closePopupmenu()
        }
    }

    onClickButton(e) {

        // Stop other logic to prevent weird behaviour
        this.stopAllEvents(e);

        // Open the popupmenu
        this.openPopupMenu(e);
    }

    closePopupmenu() {

        // Re-enable the tooltip
        this.disableTooltip = false;

        // Remove popup from DOM
        this.popup.remove();

        // Clear popup variable
        delete this.popup;

        // Remove global click listener
        document.removeEventListener('click', this.mouseUpDocument)

        if (this.wysiwyg.editor) {
            this.wysiwyg.editor.getDoc().removeEventListener('click', this.mouseUpDocument)
        }
    }

    openPopupMenu(e) {

        // Check if there isn't already a popup open
        if (this.popup === undefined) {

            // Create a new popup using the ColorPopupTemplate
            this.popup = $(ColorPopupTemplate({
                Styles
            }))

            // Add the popup to the DOM
            this.$('.js-icon-holder').after(this.popup);

            this.appendColorButtons(this.colors)

            // Disable tooltip functionality
            this.disableTooltip = true;

            // Call the onDeHoverButton function to remove tooltip if active
            this.onDeHoverButton();

            // Add global click listener
            document.addEventListener('click', this.mouseUpDocument)

            if (this.wysiwyg.editor) {
                this.wysiwyg.editor.getDoc().addEventListener('click', this.mouseUpDocument)
            }

            this.addColorButtonListeners()

            // Else when popup is open and clicked target is not popup
        } else if (!$.contains(this.popup[0], e.target) &&
            !this.popup.is(e.target)
        ) {
            // Close popupmenu
            this.closePopupmenu();
        }
    }

    /**
     * Add click listeners for when color buttons are clicked
     */
    addColorButtonListeners() {
        // Search in this.popup for color buttons and added click listener to is
        this.popup.find('.js-color-button').on('click', this.onChosenColor);
    }

    /**
     *
     * @param {string[]} colors
     * colors
     * @param {boolean} isInitial
     * prevents adding event listener if it already has been set
     */
    appendColorButtons(colors, isInitial = false) {
        const colorsContainer = this.$('.js-colors')

        colorsContainer.empty()

        for (const color of colors) {
            const button = ColorsButtonTemplate({
                color: `${color}`,
            })

            colorsContainer.append(button)
        }

        if (!isInitial) {
            this.addColorButtonListeners()
        }
    }

    onChosenColor(e) {

        // Stop all the events
        this.stopAllEvents(e);

        // Distill the color from the clicked element
        const color = $(e.currentTarget).data('color');

        // Execute the MCE command
        this.wysiwyg.onMceCommand(this, color);

        // Close popupmenu after choosing color
        this.closePopupmenu();
    }

}
